var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 4.85A2.85 2.85 0 0 1 4.85 2h3.28c.796 0 1.502.51 1.754 1.265l1.498 4.494a1.85 1.85 0 0 1-.928 2.24l-1.497.748a10.2 10.2 0 0 0 3.996 3.996l.749-1.497a1.85 1.85 0 0 1 2.24-.928l4.493 1.498A1.85 1.85 0 0 1 21.7 15.57v3.28a2.85 2.85 0 0 1-2.85 2.85h-1C9.096 21.7 2 14.603 2 5.85zM4.85 3.7A1.15 1.15 0 0 0 3.7 4.85v1C3.7 13.665 10.035 20 17.85 20h1A1.15 1.15 0 0 0 20 18.85v-3.28a.15.15 0 0 0-.103-.141l-4.493-1.498.269-.807-.269.807a.15.15 0 0 0-.182.075l-1.128 2.257a.85.85 0 0 1-1.11.395 11.9 11.9 0 0 1-5.942-5.942.85.85 0 0 1 .395-1.11l2.257-1.128a.15.15 0 0 0 .075-.182L8.272 3.803l.792-.265-.792.265a.15.15 0 0 0-.143-.103z",
  clipRule: "evenodd"
})));
export default SvgPhone;